import React from "react";
import PeleImg from "../../images/icons/pele.png";

const PeleIcon = ({ width = "30px", className }) => {
  return (
    <img
      src={PeleImg}
      alt="PeleIcon"
      className={className}
      style={{ width: width, height: "30px" }}
    />
  );
};

export default PeleIcon;
